import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useSEO } from '../../hooks/useSEO';
import { SITE_URL } from '../../utils/siteConfig';

const sections = [
  {
    title: '1. Toepasselijkheid',
    items: [
      '1.1 Deze algemene voorwaarden zijn van toepassing op alle offertes, overeenkomsten en leveringen van DUC – Direct uit China (hierna: "DUC").',
      '1.2 Door een bestelling te plaatsen, gaat de klant automatisch akkoord met deze voorwaarden.',
    ],
  },
  {
    title: '2. Dienstverlening',
    items: [
      '2.1 DUC treedt op als bemiddelaar en sourcingpartner tussen de klant en (voornamelijk Chinese) fabrikanten.',
      '2.2 DUC verzorgt onder andere:\n• Product sourcing\n• Onderhandelingen met leveranciers\n• Coördinatie van productie\n• Logistieke begeleiding\n• Kwaliteitscontrole (beperkt, zie artikel 14)',
      '2.3 DUC is geen producent van de goederen.',
    ],
  },
  {
    title: '3. Offertes en prijzen',
    items: [
      '3.1 Alle offertes zijn vrijblijvend, tenzij schriftelijk anders aangegeven.',
      '3.2 Prijzen zijn gebaseerd op actuele kosten zoals:\n• Grondstoffen\n• Wisselkoersen\n• Transporttarieven',
      '3.3 DUC behoudt het recht om prijzen aan te passen bij:\n• Valutaschommelingen\n• Veranderingen in transportkosten\n• Aanpassingen vanuit leveranciers',
      '3.4 DUC streeft ernaar de laagst mogelijke prijs te realiseren. Indien de klant na bestelling elders een lagere prijs vindt, kan de bestelling niet worden geannuleerd.',
    ],
  },
  {
    title: '4. Productinformatie en visuals',
    items: [
      '4.1 DUC verstrekt waar mogelijk foto\'s, video\'s of productvoorbeelden.',
      '4.2 Kleine afwijkingen in kleur, afwerking, formaat of verpakking zijn inherent aan productie en vormen geen grond voor klachten.',
    ],
  },
  {
    title: '5. Samples en verantwoordelijkheid klant',
    items: [
      '5.1 De klant is verantwoordelijk voor het aanvragen en beoordelen van een sample vóór plaatsing van een bulkbestelling.',
      '5.2 Indien geen sample wordt aangevraagd, ligt het volledige risico bij de klant.',
      '5.3 Klachten over kwaliteit of uitvoering na productie worden in dat geval niet geaccepteerd.',
    ],
  },
  {
    title: '6. Bestelling en goedkeuring',
    items: [
      '6.1 De klant is verantwoordelijk voor het controleren en goedkeuren van:\n• Ontwerpen\n• Specificaties\n• Aantallen',
      '6.2 Na goedkeuring en/of start van productie kunnen geen wijzigingen meer worden doorgevoerd.',
    ],
  },
  {
    title: '7. Betaling',
    items: [
      '7.1 Bestellingen worden pas in behandeling genomen na (gedeeltelijke of volledige) betaling.',
      '7.2 Alle betalingen zijn definitief en niet-restitueerbaar.',
      '7.3 Bij niet-tijdige betaling behoudt DUC zich het recht voor om:\n• Leveringen op te schorten\n• Extra kosten in rekening te brengen',
    ],
  },
  {
    title: '8. Annulering',
    items: [
      '8.1 Annulering van bestellingen is niet mogelijk na bevestiging en/of start van productie.',
      '8.2 Dit geldt in alle gevallen, ongeacht reden of omstandigheden.',
    ],
  },
  {
    title: '9. Levertijden',
    items: [
      '9.1 Alle door DUC gecommuniceerde levertijden zijn indicatief en gebaseerd op schattingen.',
      '9.2 De klant ontvangt, indien beschikbaar, een track & trace code voor de zending.',
      '9.3 Levertijden zijn afhankelijk van:\n• Productietijd\n• Transport\n• Douaneafhandeling\n• Externe factoren buiten invloed van DUC',
      '9.4 Het kan voorkomen dat productie langer duurt dan verwacht of dat verzending vertraging oploopt.',
      '9.5 De opgegeven levertijden zijn daarom niet bindend en kunnen niet worden beschouwd als een fatale termijn.',
      '9.6 Aan opgegeven levertijden kunnen geen rechten worden ontleend en deze zijn niet juridisch afdwingbaar.',
      '9.7 DUC is niet aansprakelijk voor vertragingen in levering.',
    ],
  },
  {
    title: '10. Levering en transport',
    items: [
      '10.1 Levering vindt plaats via externe transporteurs.',
      '10.2 DUC is niet aansprakelijk voor:\n• Vertragingen\n• Verlies\n• Schade tijdens transport',
    ],
  },
  {
    title: '11. Niet-thuis bij levering en opslag',
    items: [
      '11.1 Indien de klant niet aanwezig is bij levering kan de zending:\n• Opnieuw aangeboden worden\n• Worden opgeslagen bij het transportbedrijf\n• Worden doorgestuurd naar een locatie van DUC',
      '11.2 Alle bijkomende kosten voor opslag, herlevering en doorzending zijn voor rekening van de klant.',
      '11.3 Indien levering structureel niet mogelijk blijkt, behoudt DUC zich het recht om verdere actie te bepalen zonder recht op restitutie.',
      '11.4 Indien een zending retour wordt gestuurd naar China door herhaaldelijk mislukte levering, dient de klant opnieuw alle verzendkosten te betalen.',
    ],
  },
  {
    title: '12. Douane en importverplichtingen',
    items: [
      '12.1 DUC informeert de klant vooraf over eventuele douane- en importverplichtingen.',
      '12.2 Indien wordt gekozen voor DDP (Delivered Duty Paid) transport, zijn invoerrechten, BTW en douanekosten inbegrepen in de prijs, en komen er geen extra kosten bij aankomst voor de klant.',
      '12.3 Indien niet wordt gekozen voor DDP transport:\n• Zijn alle invoerrechten, BTW en bijkomende kosten volledig voor rekening van de klant.',
      '12.4 DUC is niet aansprakelijk voor:\n• Onjuiste inschattingen van douanekosten\n• Vertragingen bij de douane\n• Aanpassingen in wet- en regelgeving',
    ],
  },
  {
    title: '13. Kwaliteit en aansprakelijkheid',
    items: [
      '13.1 DUC is niet aansprakelijk voor:\n• Productiefouten\n• Kwaliteitsverschillen\n• Afwijkingen in afwerking\n• Transportschade',
      '13.2 DUC zal waar mogelijk bemiddelen bij problemen, maar geeft geen garanties op oplossingen of compensatie.',
      '13.3 Indien na levering blijkt dat producten niet voldoen aan verwachtingen, ligt de verantwoordelijkheid bij de klant indien geen sample is afgenomen.',
    ],
  },
  {
    title: '14. Kwaliteitscontrole (QC)',
    items: [
      '14.1 Kwaliteitscontroles zijn altijd steekproefsgewijs.',
      '14.2 Niet elk individueel product wordt gecontroleerd.',
      '14.3 Hieraan kunnen geen garanties of rechten worden ontleend.',
    ],
  },
  {
    title: '15. Maatwerk en herroepingsrecht',
    items: [
      '15.1 Alle producten worden op maat geproduceerd.',
      '15.2 Hierdoor vervalt:\n• Het herroepingsrecht\n• Het recht op retour\n• Het recht op terugbetaling',
    ],
  },
  {
    title: '16. Intellectueel eigendom en marketing',
    items: [
      '16.1 Door een bestelling te plaatsen, geeft de klant toestemming aan DUC om producten, verpakkingen en branding/logo\'s te gebruiken voor marketingdoeleinden, waaronder social media.',
      '16.2 Indien de klant dit niet wenst, dient dit vooraf schriftelijk te worden aangegeven.',
    ],
  },
  {
    title: '17. Overmacht',
    items: [
      '17.1 DUC is niet aansprakelijk voor vertragingen of tekortkomingen als gevolg van overmacht, waaronder:\n• Leveranciersproblemen\n• Transportvertragingen\n• Douane\n• Politieke of economische omstandigheden',
    ],
  },
  {
    title: '18. Bedrijfsstructuur',
    items: [
      '18.1 DUC (Direct uit China) is onderdeel van ROLGO.\n\nGegevens ROLGO:\n• KVK-nummer: 96233850\n• BTW-nummer: NL005197054B84',
      '18.2 Bestellingen via DUC en ROLGO staan volledig los van elkaar.',
      '18.3 Er bestaat geen enkele aansprakelijkheid of koppeling tussen DUC-orders en ROLGO-orders.',
    ],
  },
  {
    title: '19. Slotbepaling',
    items: [
      '19.1 DUC streeft naar een zo soepel en professioneel mogelijke afhandeling van alle orders.',
      '19.2 De klant erkent dat internationale handel risico\'s met zich meebrengt.',
      '19.3 Door een bestelling te plaatsen, accepteert de klant deze risico\'s volledig.',
    ],
  },
];

export default function AlgemeneVoorwaardenPage() {
  useSEO({
    title: 'Algemene Voorwaarden | Direct Uit China (DUC) — Import & Sourcing',
    description: 'De algemene voorwaarden van Direct Uit China (DUC). Lees de volledige voorwaarden voor inkopen, levering, kwaliteitscontrole en betaling. Geldig per 1 januari 2025.',
    keywords: 'algemene voorwaarden DUC, voorwaarden inkopen China, leveringsvoorwaarden Direct Uit China',
    canonical: `${SITE_URL}/algemene-voorwaarden`,
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
          { '@type': 'ListItem', position: 2, name: 'Algemene Voorwaarden', item: `${SITE_URL}/algemene-voorwaarden` },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Algemene Voorwaarden — Direct Uit China (DUC)',
        description: 'De algemene voorwaarden van Direct Uit China (DUC). Geldig per 1 januari 2025.',
        url: `${SITE_URL}/algemene-voorwaarden`,
        inLanguage: 'nl-NL',
        dateModified: '2026-03-26',
        publisher: { '@type': 'Organization', name: 'Direct Uit China (DUC)', url: SITE_URL },
      },
    ],
  });

  return (
    <div className="min-h-screen bg-[#F7F8FA]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      {/* Nav */}
      <header className="bg-[#0A1628] sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-28 flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/15bdf5788918520e40e960585d4ea965/3037d4ed8e2d758e66815cdcd69eb3cd.png"
              alt="DUC - Direct uit China"
              className="h-[100px] w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-white/70 hover:text-[#3B9EE8] text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Terug naar home
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-[#0A1628] pb-16 pt-14">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-flex items-center gap-2 border border-[#3B9EE8]/40 bg-[#3B9EE8]/10 rounded-full px-4 py-2 text-[#3B9EE8] text-sm font-semibold mb-6">
              <i className="ri-file-text-line" />
              Juridisch
            </span>
            <h1 className="text-white text-4xl md:text-5xl font-bold mb-3">Algemene Voorwaarden</h1>
            <p className="text-white/50 text-base">
              DUC – Direct uit China &nbsp;·&nbsp; Geldig per 1 januari 2025
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="bg-white rounded-2xl border border-[#0A1628]/8 overflow-hidden">
            {sections.map((section, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: Math.min(i * 0.03, 0.4) }}
                className={`px-8 py-7 ${i < sections.length - 1 ? 'border-b border-[#0A1628]/6' : ''}`}
              >
                <h2 className="text-[#0A1628] font-bold text-base mb-4 flex items-center gap-2">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-[#3B9EE8]/15 text-[#3B9EE8] text-xs font-bold flex-shrink-0">
                    {i + 1}
                  </span>
                  {section.title.replace(/^\d+\.\s*/, '')}
                </h2>
                <div className="flex flex-col gap-3">
                  {section.items.map((item, j) => (
                    <p key={j} className="text-[#0A1628]/60 text-sm leading-relaxed whitespace-pre-line">
                      {item}
                    </p>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-8 p-6 bg-[#0A1628] rounded-xl flex flex-col md:flex-row items-center justify-between gap-4">
            <div>
              <p className="text-white font-semibold text-sm">Vragen over onze voorwaarden?</p>
              <p className="text-white/45 text-xs mt-0.5">
                Neem contact op via&nbsp;
                <a href="mailto:Info@directuitchina.nl" className="text-[#3B9EE8] hover:underline">
                  Info@directuitchina.nl
                </a>
                &nbsp;of WhatsApp.
              </p>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#3B9EE8] hover:bg-[#2D85C5] text-white font-bold text-sm px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Neem contact op
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Related links */}
          <div className="mt-4 flex gap-3">
            <Link
              to="/privacybeleid"
              className="flex-1 p-4 bg-white rounded-xl border border-[#0A1628]/8 hover:border-[#3B9EE8]/30 transition-colors flex items-center gap-3 cursor-pointer group"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#3B9EE8]/10 text-[#3B9EE8] flex-shrink-0">
                <i className="ri-shield-check-line text-base" />
              </div>
              <div>
                <p className="text-[#0A1628] font-semibold text-sm group-hover:text-[#3B9EE8] transition-colors">Privacybeleid</p>
                <p className="text-[#0A1628]/45 text-xs">Hoe wij omgaan met jouw gegevens</p>
              </div>
            </Link>
            <Link
              to="/faq"
              className="flex-1 p-4 bg-white rounded-xl border border-[#0A1628]/8 hover:border-[#3B9EE8]/30 transition-colors flex items-center gap-3 cursor-pointer group"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#3B9EE8]/10 text-[#3B9EE8] flex-shrink-0">
                <i className="ri-question-answer-line text-base" />
              </div>
              <div>
                <p className="text-[#0A1628] font-semibold text-sm group-hover:text-[#3B9EE8] transition-colors">Veelgestelde vragen</p>
                <p className="text-[#0A1628]/45 text-xs">Antwoorden op veelgestelde vragen</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Simple footer */}
      <footer className="bg-[#050E1A] py-8 text-center">
        <p className="text-white/30 text-xs">
          &copy; {new Date().getFullYear()} Direct uit China (DUC). Alle rechten voorbehouden. &nbsp;
          <Link to="/privacybeleid" className="hover:text-white/60 transition-colors">Privacybeleid</Link>
          &nbsp;·&nbsp;
          <Link to="/contact" className="hover:text-white/60 transition-colors">Contact</Link>
          &nbsp;·&nbsp;
          <Link to="/faq" className="hover:text-white/60 transition-colors">FAQ</Link>
        </p>
      </footer>
    </div>
  );
}
